<template>
  <div class="page3">
    <el-row :gutter="20" class="flex">
      <el-col style="width: 50%;">
        <el-card class="box-card">
          <div class="side">
            <div>
              <div class="top">
                <span>登记车辆</span>
                <span style="margin:0 20px">{{stallCount}}辆</span>
              </div>
              <div class="bottom">
                <span>今日已出场</span>
                <span style="color:#17CF93;margin-left:10px">{{carNum.CarOut}}</span>
                <span style="margin-left:20px;">今日已进场</span>
                <span style="color:#17CF93;margin-left:10px">{{carNum.CarIn}}</span>
              </div>
            </div>
            <div style="margin-top: 10%;margin-left: 15%">
              <img src="../../assets/image/blue_car.png" alt="">
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col style="width: 50%;">
        <el-card class="box-card">
          <div class="side">
            <div>
              <div class="top">
                <span>今日临时车辆</span>
                <span style="margin-left:20px">{{outCarCount}}辆</span>
              </div>
              <div class="bottom">
                <span>今日已出场</span>
                <span style="color:#17CF93;margin-left:10px">{{carNum.tempCarOut}}</span>
                <span style="margin-left:20px">今日已进场</span>
                <span style="color:#17CF93;margin-left:10px">{{carNum.tempCarIn}}</span>
              </div>
            </div>
              <div style="margin-top: 10%;margin-left: 15%">
              <img src="../../assets/image/green_car.png" alt="">
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div class="else">
      <div class="echart" style="width:100%;height:100%;">
        <div id="myChart" :style="{  height: '100%',width:'100%' }"></div>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from 'echarts' //引入echarts
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
  name: 'eCharts',
  data() {
    return {
      projectId: '',
      allCarCount: '',
      freePosition: '',
      outCarCount: '',
      stallCount: '',
      carCount: [],
      carNum:{}
    }
  },
  mounted() {
    this.projectId = util.session.get('groupId')
    this.getEchart()
    this.drawLine()
    this.getData()
    this.getNum()
  },
  methods: {
    // secStallByCommunityId
    getData() {
      var that = this
      myHttp
        .selectProjectCarCount({
          projectId: this.projectId
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              console.log(resp)
              // that.allCarCount = resp.data.data.allCarCount
              // that.freePosition = resp.data.data.freePosition
              that.outCarCount = resp.data.data.tempCarCount
              that.stallCount = resp.data.data.carCount
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    // selectNowCarInOutInfo
     getNum() {
      var that = this
      myHttp
        .selectNowCarInOutInfo({
          projectId: this.projectId
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              // console.log(resp)
              // carAll:resp.data
              that.carNum = resp.data.data
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    getEchart() {
      var that = this
      // secMonthPersonAroundOneYear
     var year = new Date().getFullYear();
      myHttp
        .selectOneYearCarInOutInfo({
          projectId: this.projectId,
          year:year
        })
        .then(
          function(resp) {
            if (resp.data.code == '200') {
              var carCount = resp.data.data.inOut || []
              var tempInOut =resp.data.data.tempInOut ||[]
              var arr1 = []
              var arr2 = []
              for (var i = 0; i < carCount.length; i++) {
                arr1.push(carCount[i].count)
              }
              for (var i = 0; i < tempInOut.length; i++) {
                arr2.push(tempInOut[i].count)
              }
              that.drawLine(arr1,arr2)
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
    drawLine(carCount,tempInOut) {
      var myChart = this.$echarts.init(document.getElementById('myChart'))
      // 绘制线形图表
       myChart.setOption({
        title: {
          text: '车辆进出次数'
        },
        color: ['#16BBCF', '#FFB533'],
        tooltip: {
          show: true,
          trigger: 'axis',
          showDelay: 0, //显示延时，添加显示延时可以避免频繁切换
          hideDelay: 50, //隐藏延时
          transitionDuration: 0, //动画变换时长
          backgroundColor: 'rgba(0,0,0,0.9)', //背景颜色（此时为默认色）
          borderRadius: 8, //边框圆角
          padding: 10, // [5, 10, 15, 20] 内边距
          position: function(p) {
            return [p[0] + 10, p[1] - 10]
          }
        },
         legend: {
          show: true,
          icon: 'circle',
          data: ['登记车辆进出', '临时车辆进出'],
          top: '-1%',
          right: '3%',
          textStyle: {
            fontSize: 12,
            color: '#666'
          }
        },
        grid: {
          left: '3%',
          right: '3%',
          // bottom: '0%',
          // top: '15%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [
              '1月份',
              '2月份',
              '3月份',
              '4月份',
              '5月份',
              '6月份',
              '7月份',
              '8月份',
              '9月份',
              '10月份',
              '11月份',
              '12月份'
            ],
            axisTick: {
              show: false,
              alignWithLabel: true
            },
            axisLine: {
              //y轴
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#1B3BF5',
                fontWeight: 'Bold'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            // min: 100,
            // max: 2000,
            // interval: 500,
            splitArea: {
              // show: true  灰白背景
            },
            axisTick: {
              //y轴刻度线
              show: false
            },
            axisLine: {
              //y轴
              show: false
            }
          }
        ],
        series: [
          {
            name: '登记车辆进出',
            type: 'bar',
            barWidth: '16',
            itemStyle: {
              normal: {
                //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  {
                    offset: 0,
                    color: '#16BBCF'
                  },
                  // {
                  //   offset: 1,
                  //   color: '#C7EFFB'
                  // }
                ])
              }
            },
            data: carCount
          },
          {
            name: '临时车辆进出',
            type: 'bar',
            barWidth: '16',
            itemStyle: {
              normal: {
                //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  {
                    offset: 0,
                    color: '#FEC503'
                  },
                  // {
                  //   offset: 1,
                  //   color: '#F38EFB'
                  // }
                ])
              }
            },
            data:tempInOut
          },
        ]
      })
    }
  }
}
</script>
<style  scoped>
.cssTest {
  float: left;
  width: 125px;
  height: 220px;
  border: 2px solid #17cf93;
  position: relative;
  left: 0px;
  top: 0px;
  background: #17cf93;
}
.cssTest > img {
  position: absolute;
  top: 85px;
  left: 35px;
}
.triangle-right {
  width: 0;
  height: 0;
  border-top: 30px solid transparent;
  border-left: 30px solid #17cf93;
  border-bottom: 30px solid transparent;
  position: absolute;
  top: 35%;
  left: 100%;
}
.page3 {
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
}
.page3 >>> .el-card__body {
  padding: 0px !important;
}
.page3 .inputLis div .el-input__inner {
  height: 40px;
  border: 0 none;
  font-size: 16px;
  color: #707070;
}

.page3 .el-row {
  margin-top: 20px;
  border-radius: 4px;
  margin-left: 0px !important; 
  margin-right: 0px !important;
}

.page3 .el-row:last-child {
  margin-bottom: 30px;
}

/* .page3 .el-row:nth-child(3) .el-col .el-card,
.page3 .el-row:nth-child(4) .el-col .el-card {
  height: 360px;
} */

.page3 .echart-pie {
  margin-left: -20px;
  margin-top: 20px;
}

.text {
  font-size: 16px;
}

.page3 .item {
  position: absolute;
  left: 18px;
  top: -5px;
  padding: 18px 0;
}

.page3 .item-bot {
  position: absolute;
  left: 26px;
  bottom: 0px;
  padding: 15px 0;
  font-size: 16px;
  color: #ffbc01;
}

.page3 .box-card {
  position: relative;
  /* padding: 10px; */
}
.flex {
  display: flex;
  justify-content: space-between;
}
.top {
  height: 70px;
  padding: 30px;
  border-bottom: 1px solid #f5f5f5;
  text-align: left;
}
.bottom {
  height: 150px;
  padding: 30px;
  line-height: 90px;
  color: #707070;
  font-weight: bolder;
}
.side {
  display: flex;
}
.else {
  height: calc(100% - 260px);
  background: #fff;
  width: 100%;
  margin: auto;
  margin-top: 20px;
  padding-top: 20px;
}
</style>